import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import 'material-components-web/dist/material-components-web.min.css';
import "babel-polyfill";

import './App.css';


import Signin from './views/Signin'
import Signup from './views/Signup'
import ConfirmRegistration from './views/ConfirmRegistration'
import RegenerateOTP from './views/RegenerateOTP'
import ForgotPassword from './views/ForgotPassword'
import TokenLogin from './views/TokenLogin'
import CentaFCRegistration from './views/centa/CentaFCRegistration'
import CentaMCRegistration from './views/centa/CentaMCRegistration'
import CentaTPORegistration from './views/centa/CentaTPORegistration'
import CentaTQRegistration from './views/centa/CentaTQRegistration'
import CentaTPOResults from './views/centa/CentaTPOResults'
import Logout from './views/Logout'


import Main from './layout/Main'

import PrivateRoute from './helpers/PrivateRoute'
//<Route exact path="/portal/app/user/roadmaps" component={UserRoadmaps} />
//<Route exact path="/portal/app/user/learning_path_main_page" component={LearningPathMainPage} />

const App = () => (
  <div>
    <Switch>
      <PrivateRoute path="/portal/app" component={Main} />
      <Route exact path="/portal/signin/:typeName" component={Signin} />
      <Route exact path="/portal/signin" component={Signin} />
      <Route exact path="/portal/signup" component={Signup} />
      <Route exact path="/portal/confirm_registration" component={ConfirmRegistration} />
      <Route exact path="/portal/regenerate_otp" component={RegenerateOTP} />
      <Route exact path="/portal/forgot_password" component={ForgotPassword} />
      <Route exact path="/portal/token_login" component={TokenLogin} />
      <Route exact path="/portal/centa_fc_registration" component={CentaFCRegistration} />
      <Route exact path="/portal/centa_mc_registration" component={CentaMCRegistration} />
      <Route exact path="/portal/centa_tpo_registration" component={CentaTPORegistration} />
      <Route exact path="/portal/centa_tq_registration/:name" component={CentaTQRegistration} />
      <Route exact path="/portal/centa_tpo_results" component={CentaTPOResults} />
      <Route exact path="/portal/logout" component={Logout}/>
      <Route exact path='/portal/' render={() => (
          <Redirect
            to='/portal/app'
          />
        )} />
    </Switch>
  </div>
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js